import { useNavigation, usePathname } from "expo-router";
export function useGetPageTitle() {
	var pathname = usePathname();
	switch (pathname) {
		case "/admin/groups":
			return "Groups + Sites";
		case "/admin/users":
			return "Users";
		case "/admin/stocklists":
			return "Stocklists";
		case "/admin/checklists":
			return "Checklists";
		case "/admin/glaccounts":
			return "GL Accounts";
	}
	return "";
}
